import classnames from 'classnames';
import useExperiment from 'hooks/useExperiment';
import React from 'react';

import { Translator } from '../../Translator';

const CSS = require('./ExperienceCardAvatarLabel.module.scss');

interface ExperienceCardAvatarLabelProps {
  animate: boolean;
  nrOfHosts: number;
  text?: string;
}

function ExperienceCardAvatarLabel({
  animate,
  nrOfHosts,
  text,
}: ExperienceCardAvatarLabelProps) {
  const localPickerTest = useExperiment('localPicker');
  const classes = classnames(CSS.experienceCardAvatarLabel, {
    [CSS.experienceCardAvatarLabelAnimate]: animate,
  });

  if (localPickerTest.assignedVariant === 1) {
    return null;
  }

  return (
    <span className={classes}>
      {!!text
        ? text
        : Translator.translate(
            'ExperienceCard.Details.hostsAvailable',
            { nrOfHosts },
            true,
            '{nrOfHosts} hosts available',
          )}
    </span>
  );
}

export default ExperienceCardAvatarLabel;
